import TwentyService from '../services/twenty-service/twenty-service';
import store from '../store';

const redirectToLogin = () => {
  const currentUrl = encodeURIComponent(window.location.href);
  const url = `${process.env.TWENTY_LOGIN_PAGE}?ref=${currentUrl}`;
  window.location.replace(url);
};

const session = ({ next }) => {
  if (store.state.app.auth.session) {
    return next();
  }
  return TwentyService.getSession()
    .then(res => store.dispatch('app/setSessionInfo', res.data)
      .then(() => next()))
    .catch(() => store.dispatch('app/resetSessionInfo')
      .then(() => redirectToLogin()));
};

/* eslint-disable */
export {
  session,
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/router/middleware.js